export function IsTrashFolder(folderName) {
  switch (folderName) {
    case "Trash":
      return true;
      break;
  }

  return false;
}
